var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckWithCircleFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.378 24.01c6.628 0 12-5.373 12-12 0-2.673-.874-5.142-2.351-7.137l2.351-2.282-1.094-1.081-2.252 2.186A11.965 11.965 0 0 0 12.378.01c-6.627 0-12 5.373-12 12s5.373 12 12 12Zm8.654-20.314-9.449 9.172-4.11-3.958-1.095 1.08 5.205 5.02L22.027 4.873a12.066 12.066 0 0 0-.995-1.177Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckWithCircleFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CheckWithCircleFilled.420d7eca6e879f53fa134c7f6bc7acf3.svg";